import { Component, OnInit } from '@angular/core';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { ButtonModule } from 'primeng/button';
import { Router } from '@angular/router';
import { OrderService } from 'com.trumbull.phx.order.api-client';
import { CommonModule, DatePipe } from '@angular/common';
import { ModalComponent } from '../shared/modal/modal.component';
import { TenantService } from '../tenant.service';
import { forkJoin } from 'rxjs';
import { VocabApiService } from '../vocab/vocab.service';
import { NeedHelpModalComponent } from '../shared/modal/need-help-modal/need-help-modal.component';

@Component({
  selector: 'app-landing-page',
  imports: [InputGroupModule, InputGroupAddonModule, ButtonModule, CommonModule, ModalComponent, NeedHelpModalComponent],
  providers: [DatePipe],
  templateUrl: './landing-page.component.html',
  styleUrl: './landing-page.component.scss'
})
export class LandingPageComponent implements OnInit{

  errorFlag: boolean = false;
  errorMessage: string = '';
  showHelpModal: boolean = false;
  orderDetails: any = null;
  availableTenants: string[] = [];
  accountname?: string;

  constructor(private router: Router, private readonly orderService: OrderService,private datePipe: DatePipe,private tenantService: TenantService,private vocabService: VocabApiService) { }

    
  ngOnInit(): void {
    this.tenantService.getAvailableTenants().subscribe((tenants) => {
      this.availableTenants = tenants;
    });
  }

  toggleSearch() {
    const searchOverlay = document.getElementById('search-overlay')!;
    const profileDropdown = document.getElementById('dropdown-menu')!;
    if (searchOverlay.style.display === 'flex') {
      searchOverlay.style.display = 'none';
    } else {
      searchOverlay.style.display = 'flex';
      profileDropdown.style.display = 'none'; // Hide profile dropdown if open
    }
  }

  /**
   * navigate to order details page when order id matches
   */
  searchClicked(orderId: any) {
    this.errorFlag = false;
    const selectedTenant = localStorage.getItem('selectedTenant');
  
    const order$ = this.orderService.getOrder('standard', orderId);
    const orderData$ = this.orderService.getOrderData('standard', orderId);
  
    forkJoin([order$, orderData$]).subscribe(
      ([order, orderData]: any) => {
        this.errorFlag = false;
        this.orderDetails = {
          referenceNumber: orderData.case.referenceNumber,
          dateOfIncident: this.datePipe.transform(orderData?.case?.incidentDate,'MM/dd/yyyy','UTC'), 
          carrierName: selectedTenant,
          typeOfOrder: orderData?.retrievalObjective?.orderTypeCode,
          serviceLevel: orderData?.retrievalObjective?.serviceLevelCode,
          orderedDate: this.datePipe.transform(order.orderedDate, 'MM/dd/yyyy','UTC')
        };
        localStorage.setItem('orderDetails', JSON.stringify(this.orderDetails));
        this.router.navigate(['/home/order-details/', orderId]);
      },
      (error) => {
        console.error('No results found! Please contact us if you need assistance', error);
        this.errorFlag = true;
      }
    );
  }

  fetchUserOrganizationVocab(organizationValue: any){
    this.vocabService.getVocabData(['OrderType']).subscribe(data => {
      if (data) {
        console.log("data 1:",data);
        const vocabUserData = data?.find(d => d.vocabularyName === 'OrderType');
        if (vocabUserData) {
         let vocabData = vocabUserData?.vocabularyItems?.find(item => item?.code === organizationValue);
         console.log("data 2:",vocabData);
         this.accountname = vocabData?.description;
        }
       }
    });
  }

  contactUs() {
    this.showHelpModal = true;
  }
}
